import EducationDetail from "./detail";
import React, {useContext, useEffect, useState} from "react";
import Api from '../../../../interface/api/content/education';
import {HostStateContext} from "../../../admin/index";
import {ManagementMenuOptionItem, ManagementMenuOptionItem2} from "../../../../component/menu-item";
import Paper from "@material-ui/core/Paper";
import TableContainer from "@material-ui/core/TableContainer";

export default function Education() {
    const { hostInfo } = useContext(HostStateContext);
    const [ educationInfos, setEducationInfos ] = useState<any>([]);
    const [ selectedEducation, setSelectedEducation ] = useState({
        mode : false,
        selected : null
    });

    function modeHandler(selected) {
        setSelectedEducation({
            mode : !selectedEducation.mode,
            selected: selected
        });
        return null;
    }

    function deleteHandler(seq) {

    }

    useEffect(() => {
        Api.getEducationInfos(hostInfo.siteInfo.seq).then(res => setEducationInfos(res.data));
    }, [])

    return (
        selectedEducation.mode
            ? <EducationDetail selectedEducation={selectedEducation.selected} modeHandler={modeHandler}/>
            : <div className="nv_contents">
                <div className="nv_contents_search">
                    <button type="button" className="nv_blue_button right" onClick={() => modeHandler(null)}>작성</button>
                </div>
                <div className="nv_table_box">
                    <TableContainer component={Paper}>
                        <table className="nv_table textcenter nv_board_table" id="noticeTable">
                            <colgroup>
                                <col style={{width:'25%'}} />
                                <col style={{width:'10%'}} />
                                <col style={{width:'10%'}} />
                                <col style={{width:'15%'}} />
                                <col style={{width:'10%'}} />
                            </colgroup>
                            <thead>
                            <tr>
                                <th scope="row">제목</th>
                                <th scope="row">유효개월수</th>
                                <th scope="row">타이머</th>
                                <th scope="row">미디어 수</th>
                                <th scope="row">관리</th>
                            </tr>
                            </thead>
                            <tbody>
                            {
                                educationInfos !== undefined && educationInfos.length > 0 ?
                                educationInfos.map((row, index) => (
                                    <tr key={`educationInfosKey-${index}`}>
                                        <td>{row.name}</td>
                                        <td>{row.expiryDate}개월</td>
                                        <td>{row.timer}초</td>
                                        <td>{row.educationInfos.length}</td>
                                        <td>
                                            <ManagementMenuOptionItem items={[
                                                {
                                                    innerHTML:'수정',
                                                    onClickHandler:() => modeHandler(row)
                                                },
                                                {
                                                    innerHTML:'삭제',
                                                    onClickHandler: () => deleteHandler(row)
                                                }
                                            ]} />
                                        </td>
                                    </tr>
                                )) : <tr>
                                        <td colSpan={5}>등록된 교육이 없습니다.</td>
                                    </tr>
                            }
                            </tbody>
                        </table>
                    </TableContainer>
                    <div className="nv_table_pagenum" id="pagenation"></div>
                </div>
            </div>
    )
}